// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".main-nav-bar{border:1px solid #000}@media (max-width:768px){.main-nav-bar #nav-collapse li.form-inline{display:inline-block;flex-flow:nowrap;align-items:center;width:100%}}", ""]);
// Exports
module.exports = exports;
